import React from 'react';

const AndSeparator = () => (
  <p>&mdash;and&mdash;</p>
);

export default AndSeparator;
